<template>
  <div v-if="mobilemoney">
    <edit-mobile-money-form
      :is-active.sync="isEditing"
      :mobilemoney="mobilemoney"
      @edited="accountEdited"
    />
    <v-card-text>
      <v-row>
        <v-col cols="3">
          <key-value title="Id">
            <span class="small" v-text="mobilemoney.id"></span>
          </key-value>
          <key-value title="Title" :value="mobilemoney.title" />
          <key-value title="Owner Name" :value="mobilemoney.owner_name" />
        </v-col>
        <v-col cols="3">
          <key-value title="Operator" :value="mobilemoney.operator" />
          <key-value title="Phone Number" :value="mobilemoney.phone_number" />
        </v-col>

        <v-col cols="3">
          <key-value title="Country Code" :value="mobilemoney.account.country_code" />
          <key-value title="Country" :value="mobilemoney.country" />
        </v-col>
        <v-col cols="3">
          <h3>Actions</h3>
          <div>
            <v-btn color="primary" class="my-4" @click="isEditing = true" v-on="on">
              <v-icon>mdi-account-edit-outline</v-icon>
              Edit Account
            </v-btn>
            <v-btn color="danger" class="my-4" @click="deleteAccount" v-on="on">
              <v-icon>mdi-account-edit-outline</v-icon>
              Delete Account
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
import EditMobileMoneyForm from "./editMobileMoneyAccountForm";
export default {
  components: { EditMobileMoneyForm },
  props: {
    mobilemoney: { required: true },
  },
  data() {
    return {
      isEditing: false,
    };
  },
  methods: {
    async deleteAccount() {
      const id = this.mobilemoney.id;
      await Notify.confirm(`Please Confirm to delete the mobile account`).then(() => {
        this.$http
          .delete(`/api/v1/userMMAccounts/${id}`)
          .then((result) => {
            Notify.success(result.message);
            this.$router.back();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    accountEdited({ account }) {
      this.isEditing = false;

      this.$emit("update:account", account);
      Notify.success("Bank Account was updated successfully");
    },
  },
};
</script>
